import { useState } from 'react';
import {
  inviteMessage,
  deepLinks,
  nativeShare,
  copyToClipboard,
  type InviteMessageParts,
} from '../lib/share';

/**
 * The multi-channel share row: native share (mobile), copy link, copy the
 * formatted message, and one-tap deep links for Discord/SMS/WhatsApp/email/
 * Telegram. This is feature 1's "send it through MANY channels" surface.
 */
export function ShareRow({ parts, link }: { parts: InviteMessageParts; link: string }) {
  const [copied, setCopied] = useState<string | null>(null);
  const message = inviteMessage(parts);
  const subject = `🍿 Thursday Night: ${parts.title}`;
  const links = deepLinks(message, subject);

  const flash = (what: string) => {
    setCopied(what);
    setTimeout(() => setCopied((c) => (c === what ? null : c)), 1600);
  };

  return (
    <div>
      <div className="share-grid">
        <button
          className="share-btn"
          onClick={async () => {
            const ok = await nativeShare(subject, message, link);
            if (!ok) {
              await copyToClipboard(message);
              flash('share');
            }
          }}
        >
          <span className="ic">📤</span> Share…
        </button>
        <button
          className="share-btn"
          onClick={async () => {
            await copyToClipboard(link);
            flash('link');
          }}
        >
          <span className="ic">🔗</span> {copied === 'link' ? 'Copied!' : 'Copy link'}
        </button>
        <button
          className="share-btn"
          onClick={async () => {
            await copyToClipboard(message);
            flash('msg');
          }}
        >
          <span className="ic">📋</span> {copied === 'msg' ? 'Copied!' : 'Copy message'}
        </button>
        <a className="share-btn" href={links.sms}>
          <span className="ic">💬</span> SMS
        </a>
        <a className="share-btn" href={links.whatsapp} target="_blank" rel="noreferrer">
          <span className="ic">🟢</span> WhatsApp
        </a>
        <a className="share-btn" href={links.email}>
          <span className="ic">✉️</span> Email
        </a>
        <a className="share-btn" href={links.telegram} target="_blank" rel="noreferrer">
          <span className="ic">✈️</span> Telegram
        </a>
        <button
          className="share-btn"
          onClick={async () => {
            // Discord has no compose-with-text URL; copy the message, then open.
            await copyToClipboard(message);
            flash('discord');
            window.open(links.discord, '_blank', 'noopener');
          }}
        >
          <span className="ic">🎮</span> {copied === 'discord' ? 'Copied! →' : 'Discord'}
        </button>
      </div>
      <details style={{ marginTop: 12 }}>
        <summary className="soft" style={{ cursor: 'pointer' }}>
          Preview the message
        </summary>
        <div className="codebox" style={{ marginTop: 8 }}>
          {message}
        </div>
      </details>
    </div>
  );
}
